module.exports = __webpack_public_path__ + "img/Real Time Evaluation.a4a47a1a.png";